import { render, staticRenderFns } from "./outerTableSon.vue?vue&type=template&id=9f8d53e4&"
import script from "./outerTableSon.vue?vue&type=script&lang=js&"
export * from "./outerTableSon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports